// extracted by mini-css-extract-plugin
module.exports = {"blogs":"Blog_blogs__K99TQ"};